import { registerPlugin } from "@capacitor/core";
const CapacitorCrisp = registerPlugin("CapacitorCrisp", {
    web: () => import("./web").then((m) => new m.CapacitorCrispWeb()),
});
export * from "./definitions";
export { CapacitorCrisp };
//# sourceMappingURL=index.js.map